import { render, staticRenderFns } from "./inspectStatistics.vue?vue&type=template&id=672ea262&scoped=true"
import script from "./inspectStatistics.vue?vue&type=script&lang=js"
export * from "./inspectStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672ea262",
  null
  
)

export default component.exports